import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-pennsylvania-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./pennsylvania-state-form.component.html",
  styleUrl: "./pennsylvania-state-form.component.scss",
})
export class PennsylvaniaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
